export default __webpack_public_path__ + "static/media/2526 spice rack top.9e31c493.png";